import { PayPeriod } from 'src/types/resources/PayPeriod';
import { convertDateToServerFormat, parseISO } from 'src/utils/date';

export const getCurrentPeriod = (periods: PayPeriod[], today: string): PayPeriod | undefined =>
  periods.find(period => period.startDate <= today && today <= period.endDate);

export const toDateInterval = (period: Pick<PayPeriod, 'startDate' | 'endDate'>): { start: Date; end: Date } => ({
  start: parseISO(period.startDate),
  end: parseISO(period.endDate),
});

export const isDateInPayPeriod = (date: Date, period: PayPeriod): boolean => {
  const day = convertDateToServerFormat(date);
  return period.startDate <= day && day <= period.endDate;
};

export const getPeriodContaining = (periods: PayPeriod[], date: Date): PayPeriod | undefined =>
  periods.find(period => isDateInPayPeriod(date, period));

// the weekly pay periods start on the cutover date; every earlier one is twice-monthly
export const isWeeklyPayPeriod = (period: PayPeriod, weeklyPayPeriodsStartDate: string | undefined): boolean =>
  Boolean(weeklyPayPeriodsStartDate) && period.startDate >= weeklyPayPeriodsStartDate;

export const getPreviousPeriod = (periods: PayPeriod[], period: PayPeriod): PayPeriod | undefined => {
  const index = periods.findIndex(item => item.id === period.id);
  return index === -1 ? undefined : periods[index + 1];
};

export const getNextPeriod = (periods: PayPeriod[], period: PayPeriod): PayPeriod | undefined => {
  const index = periods.findIndex(item => item.id === period.id);
  return index <= 0 ? undefined : periods[index - 1];
};
